export class UIEntryUrlParameterController {
}
UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE = '1';
UIEntryUrlParameterController.suppressPopupsOnLoad = false;
